(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["career-join-kisko"]) return;
  try {
    

  $('.hidden-div').css({"visibility": "hidden"});   
        $(".learn-btn").click(function(){   
 $(this).parent().find('.hidden-div').toggleClass('visible', 500);
});


  } catch(e) { console.error(e); }
})();
})();
